import React from 'react';
import { Layout } from '../components/Layout';
export function VirtualRegistration() {
  return <Layout data-id="element-490">
      <div className="max-w-7xl mx-auto px-6 py-12" data-id="element-491">
        <h1 className="text-4xl font-bold text-voices-navy mb-6" data-id="element-492">
          Virtual Registration
        </h1>
        <p className="text-lg text-gray-700 mb-8" data-id="element-493">
          Register to attend Voices Live 2026 virtually from anywhere in the
          world.
        </p>
        <form className="bg-white p-8 rounded-xl shadow-md border border-gray-200 max-w-2xl mx-auto" data-id="element-494">
          <div className="space-y-6" data-id="element-495">
            <div data-id="element-496">
              <label htmlFor="name" className="block text-gray-700 font-medium mb-2" data-id="element-497">
                Full Name
              </label>
              <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-gold focus:border-voices-gold" placeholder="Enter your full name" data-id="element-498" />
            </div>
            <div data-id="element-499">
              <label htmlFor="email" className="block text-gray-700 font-medium mb-2" data-id="element-500">
                Email Address
              </label>
              <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-gold focus:border-voices-gold" placeholder="Enter your email address" data-id="element-501" />
            </div>
            <div data-id="element-502">
              <label htmlFor="location" className="block text-gray-700 font-medium mb-2" data-id="element-503">
                Location
              </label>
              <input type="text" id="location" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-voices-gold focus:border-voices-gold" placeholder="City, Country" data-id="element-504" />
            </div>
            <button type="submit" className="w-full bg-voices-navy text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-900 transition-colors" data-id="element-505">
              Complete Registration
            </button>
          </div>
        </form>
      </div>
    </Layout>;
}